import Box from 'components/shared/Box'
import DifferentHours from 'components/shared/DifferentHours'
import Text from 'components/shared/Text'
import { useRef, useState } from 'react'
import { OpeningHoursDto } from 'store/api-slice/hooks'
import {
    SeasonName,
    SeasonTitleTile,
    SliderWrapper,
    StyledBadge,
} from './styles'
import badgeStar from 'assets/icons/badge_star.svg'
import { useElementHorizontalScroll } from './useElementHorizontalScroll'
import { SliderButton } from './SliderButton'

export interface SectionProps {
    seasons: OpeningHoursDto[]
}

const DesktopSection = ({ seasons }: SectionProps) => {
    const [activeSeason, setActiveSeason] = useState(
        seasons.find((item) => item.isDefault) || seasons[0]
    )

    const sliderRef = useRef<HTMLDivElement>(null)

    const { handleScroll, hasNextButton, hasPrevButton } =
        useElementHorizontalScroll(sliderRef)

    return (
        <Box gap={30} isFullWidth style={{ position: 'relative' }}>
            <SliderWrapper isFullWidth ref={sliderRef}>
                <Box direction="row" justify="space-between" gap={12}>
                    {seasons
                        .filter(
                            (season) =>
                                season.isDefaultSpecial || !season.isSpecial
                        )
                        .map((season, index) => {
                            const { title } = season

                            if (!title) return null

                            const isActive = activeSeason.title === title

                            const seasonName = title.slice(
                                0,
                                title.indexOf('(') !== -1
                                    ? title.indexOf('(')
                                    : title.length + 1
                            )
                            const seasonDate = title.slice(
                                title.indexOf('(') !== -1
                                    ? title.indexOf('(')
                                    : title.length + 1,
                                title.length + 1
                            )

                            return (
                                <SeasonTitleTile
                                    key={`${title + index}desktopHeader`}
                                    as="button"
                                    pt={8}
                                    pb={12}
                                    pr={12}
                                    pl={12}
                                    bgColor="grayscale_0"
                                    justify="center"
                                    isActive={isActive}
                                    onClick={() => setActiveSeason(season)}
                                    data-testid={`opening-hours-tab-${index}`}
                                >
                                    <SeasonName
                                        variant="bodySmallStrong"
                                        align="left"
                                        color={
                                            isActive
                                                ? 'grayscale_900'
                                                : 'grayscale_800'
                                        }
                                        isSpecial={season.isSpecial}
                                    >
                                        {seasonName}
                                    </SeasonName>
                                    {!!seasonDate && (
                                        <Text
                                            variant="bodySmallStrong"
                                            align="left"
                                            color={
                                                isActive
                                                    ? 'grayscale_900'
                                                    : 'grayscale_800'
                                            }
                                        >
                                            {seasonDate}
                                        </Text>
                                    )}
                                    {season.isDefaultSpecial && (
                                        <StyledBadge src={badgeStar} alt="" />
                                    )}
                                </SeasonTitleTile>
                            )
                        })}
                </Box>
            </SliderWrapper>
            {hasPrevButton && (
                <SliderButton direction="prev" onClick={handleScroll} />
            )}
            {hasNextButton && (
                <SliderButton direction="next" onClick={handleScroll} />
            )}
            <DifferentHours season={activeSeason} />
        </Box>
    )
}

export default DesktopSection
